import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=3dc13bfe&scoped=true&"
import script from "./shareDialog.vue?vue&type=script&lang=js&"
export * from "./shareDialog.vue?vue&type=script&lang=js&"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=3dc13bfe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc13bfe",
  null
  
)

export default component.exports